import React from "react";
import { NavLink } from "react-router-dom";
import LinkButton from "./LinkButton";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";

const Card = ({ icon, title, desc, points, link, className }) => {
  return (
    <NavLink
      to={link}
      className={`w-full flex flex-col justify-between p-6 rounded-4xl bg-navy border border-white/20 ${className}`}
    >
      <div>
        <div className="mb-4 w-14 h-14 rounded-full bg-navy-dark flex items-center justify-center overflow-hidden">
          {icon}
        </div>
        <p className="text-2xl font-medium mb-2 header text-white">{title}</p>
        <p className="text-xl text-gray-450">{desc}</p>
        {points && (
          <div
            className="my-5 bg-navy-light rounded-xl px-3 py-4 text-base text-gray-300 space-y-2
              min-h-[144px] flex flex-col justify-center"
          >
            {points.map((point, index) => (
              <div key={index} className="flex items-start space-x-2">
                <CheckIcon
                  fill="#2970FF"
                  width="16px"
                  height="24px"
                  className="flex-none"
                />
                <p>{point}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <LinkButton label="Learn More" white />
    </NavLink>
  );
};

export default Card;
